import { DSModal } from "@components/design-system/organisms";

export function CancelRecordingModal({
  shouldShowCancelRecordingModal,
  setShouldShowCancelRecordingModal,
  cancelRecording,
}) {
  return (
    <DSModal
      isOpen={shouldShowCancelRecordingModal}
      onClose={() => setShouldShowCancelRecordingModal(false)}
      title="Cancel this recording?"
      dataTestId="cancel-recording-modal"
      actions={[
        {
          label: "Keep recording",
          variant: "cancel",
          onClick: () => setShouldShowCancelRecordingModal(false),
        },
        {
          label: "Yes, cancel",
          variant: "primary",
          onClick: () => {
            cancelRecording();
            setShouldShowCancelRecordingModal(false);
          },
          dataTestId: "confirm-button",
        },
      ]}
    >
      <h5>
        Are you sure you&apos;d like to cancel this recording? You
        will lose all the audio you&apos;ve recorded so far.
      </h5>
    </DSModal>
  );
}
